import type { NextPage } from 'next'
import { PrintFileErrors } from '@/client/modules/PrintFileErrors'
import { TutorialsProps } from '@/client/modules/Tutorials/types'
import { getCMSContent } from '@/client/utils'

const PrintFileErrorsPage: NextPage<TutorialsProps> = (data) => <PrintFileErrors {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'PRINT_FILE_ERRORS_FULL')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default PrintFileErrorsPage
